import { CUSTOM_MOBILE_BREAKPOINT, GridBreakpoints } from '@/components/GridItemCard/FluidItemGrid/FluidItemGrid';
import { mergedCaterwaulAndHammerUIThemes as theme } from '@/theme/mergedCaterwaulAndHammerUIThemes';

export const breakpoints: GridBreakpoints = {
    breakpoints: {
        [theme.breakpoints.mdMinValue]: {
            column: 3,
            gap: {
                column: theme.spacing.mdValue,
                row: theme.spacing.lgValue,
            },
        },
        [CUSTOM_MOBILE_BREAKPOINT]: {
            column: 2,
        },
    },
    column: 1,
    gap: {
        column: theme.spacing.smValue,
        row: theme.spacing.smValue,
    },
};
